module.exports = __webpack_public_path__ + "img/KM211.221.bb48fd1d.png";